/* eslint-disable react/prop-types */
import { HeaderGlobalAction as CarbonHeaderGlobalAction } from '@carbon/react';

export const HeaderGlobalAction = ({ children, ...props }) => (
  <CarbonHeaderGlobalAction {...props}>{children}</CarbonHeaderGlobalAction>
);
